import { Route } from '@angular/router';
import { ConnectionsComponent } from './connections/connections.component';
import { ProgramComponent } from './program/program.component';
import { GermplasmComponent } from './germplasm/germplasm.component';
import { EntitySelectorComponent } from './entity-selector/entity-selector.component';
import { TrialComponent } from './trial/trial.component';
import { StudyComponent } from './study/study.component';
import { ObservationUnitComponent } from './observation-unit/observation-unit.component';
import { VariableComponent } from './variable/variable.component';
import { ObservationComponent } from './observation/observation.component';
import { BrapiSyncComponent } from './brapi-sync.component';

export const BRAPI_SYNC_ROUTES: Route[] = [
    {
        path: '',
        component: BrapiSyncComponent,
        data: { pageTitle: 'brapi-sync.title' },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'connections'
            },
            {
                path: 'connections',
                component: ConnectionsComponent,
                outlet: 'brapi-sync-outlet'
            },
            {
                path: 'program',
                component: ProgramComponent,
                outlet: 'brapi-sync-outlet'
            },
            {
                path: 'entity-selector',
                component: EntitySelectorComponent,
                outlet: 'brapi-sync-outlet'
            },
            {
                path: 'germplasm',
                component: GermplasmComponent,
                outlet: 'brapi-sync-outlet'
            },
            {
                path: 'trial',
                component: TrialComponent,
                outlet: 'brapi-sync-outlet'
            },
            {
                path: 'study',
                component: StudyComponent,
                outlet: 'brapi-sync-outlet'
            },
            {
                path: 'observation-unit',
                component: ObservationUnitComponent,
                outlet: 'brapi-sync-outlet'
            },
            {
                path: 'variable',
                component: VariableComponent,
                outlet: 'brapi-sync-outlet'
            },
            {
                path: 'observation',
                component: ObservationComponent,
                outlet: 'brapi-sync-outlet'
            }
        ]
    }


];
